module.exports = __webpack_public_path__ + "static/media/T14-T25-03.ea294735.svg";